const trailContainer = document.createElement('div');
trailContainer.id = 'trail-container';
document.body.appendChild(trailContainer);

// Array of spice images (update paths to match your setup)
const spiceImages = [
  'https://cdn.shopify.com/s/files/1/0635/1709/8175/files/Spices_Illustration_chilli.png?v=1736107832',
  'https://cdn.shopify.com/s/files/1/0635/1709/8175/files/Spices_Illustration_cardi1.png?v=1736107832',
  'https://cdn.shopify.com/s/files/1/0635/1709/8175/files/Spices_Illustration_cardi2.png?v=1736107832',
  'https://cdn.shopify.com/s/files/1/0635/1709/8175/files/Spices_Illustration_cinn.png?v=1736107832',
  'https://cdn.shopify.com/s/files/1/0635/1709/8175/files/Spices_Illustration_clov2.png?v=1736107832',
  'https://cdn.shopify.com/s/files/1/0635/1709/8175/files/Spices_Illustration_ging.png?v=1736107832',
  'https://cdn.shopify.com/s/files/1/0635/1709/8175/files/Spices_Illustration_clov1.png?v=1736107832',
  'https://cdn.shopify.com/s/files/1/0635/1709/8175/files/Spices_Illustration_mace.png?v=1736107832',
  'https://cdn.shopify.com/s/files/1/0635/1709/8175/files/Spices_Illustration_chilli2.png?v=1736110917',
  'https://cdn.shopify.com/s/files/1/0635/1709/8175/files/Spices_Illustration_clov3.png?v=1736110917'
];

// Throttle function
function throttleEvent(callback, delay) {
  let lastExecutionTime = 0;

  return function (...args) {
    const currentTime = Date.now();
    if (currentTime - lastExecutionTime >= delay) {
      lastExecutionTime = currentTime;
      callback(...args);
    }
  };
}


// Function to handle the creation of trail particles
function createTrail(e) {
  // For touch event, we need to handle multiple touches (use the first one)
  const x = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
  const y = e.type === 'mousemove' ? e.clientY : e.touches[0].clientY;

  // Create a trail particle
  const trail = document.createElement('div');
  trail.className = 'trail';
  trail.style.left = `${x}px`;
  trail.style.top = `${y}px`;

  // Randomly pick a spice image
  const randomSpice = spiceImages[Math.floor(Math.random() * spiceImages.length)];
  trail.style.backgroundImage = `url(${randomSpice})`;

  // Append the particle and remove after animation
  trailContainer.appendChild(trail);
  setTimeout(() => trail.remove(), 1000); // Match animation duration
}

// Attach throttled event listener for both mousemove and touchmove
document.addEventListener('mousemove', throttleEvent((e) => {
  createTrail(e);
}, 100));  // Adjust delay as needed

document.addEventListener('touchmove', throttleEvent((e) => {
  createTrail(e);
}, 100));  // Same delay for touch events